// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1gWkv","paramInput":"JobSimulator_paramInput__2HCcy","input":"JobSimulator_input__3vOJ4"};